import { match } from "assert";

var initialState =
{
    canMoveDoor: true,
    canMoveStove: true,
    drawBenchCadPicture: true,
    filterShapesBySize: false,
    slideConfig: "default",
    allowSkipMeasurements: true,
    showNoLightOption: true,
    allowDoorModification: true,
    allowRemovalOfPanels: true,
    renderFrontWall: true,
    displayAllShapes: false,
    benchMirrorBehavior: "by_mirroring_bench",
    showResellerAssistanceRequest: false
}
const clientConfiguration = (state = initialState, action) => {
    switch (action.type) {
        case 'CLIENT_COFIGURATION_UPDATED':
            return Object.assign({}, state, {
                availableStoves: action.configuration.availableStoves,
                availablePanelMaterials: action.configuration.availablePanelMaterials,
                showPrices: action.configuration.showPrices,
                slideConfig: action.configuration.slideConfig,
                showPanelDirection: action.configuration.showPanelDirection,
                canMoveDoor: action.configuration.canMoveDoor,
                canMoveStove: action.configuration.canMoveStove,
                showInstructionBox: action.configuration.showInstructionBox,
                drawBenchCadPicture: action.configuration.drawBenchCadPicture,
                allowSkipMeasurements: action.configuration.allowSkipMeasurements,
                allowRemovalOfPanels: action.configuration.allowRemovalOfPanels,
                showNoLightOption: action.configuration.showNoLightOption,
                renderFrontWall: action.configuration.renderFrontWall,
                filterShapesBySize: action.configuration.filterShapesBySize,
                allowDoorModification: action.configuration.allowDoorModification,
                displayAllShapes: action.configuration.displayAllShapes,
                benchMirrorBehavior: getBenchMirrorBehavior(action.configuration),
                showResellerAssistanceRequest: action.configuration.showResellerAssistanceRequest
            })
        case 'CHANGE_SLIDE_CONFIG':
            return Object.assign({}, state, {
                slideConfig: action.slideConfig
            })
        default:
            return state;
    }
}

export default clientConfiguration

let getBenchMirrorBehavior = (configuration) => {

    if (configuration.availableBenchShapes) {
        let allShapes = [];
        configuration.availableBenchShapes.map(s => s.models.map(m => allShapes.push(m)));
        if (allShapes.find(s => s.mirrored === false || s.mirrored === true)) {
            return "by_selecting_shape";
        }
    }
    else return "by_mirroring_bench";
}